import React from 'react';
import PropTypes from 'prop-types';
import {
    Accordion,
    AccordionItem,
    AccordionButton,
    AccordionPanel,
    Box,
    Flex,
    Text,
    useBreakpointValue
} from '@chakra-ui/react';
import {AddIcon, CloseIcon} from '@chakra-ui/icons';
import {getComponentByType} from "../../DynamicComponent";

const AccordionComponent = ({content}) => {
    AccordionComponent.propTypes = {
        content: PropTypes.shape({
            starLabel: PropTypes.string,
            accordionItems: PropTypes.array.isRequired,
        }),
    };
    const isMobile = useBreakpointValue({base: true, md: false});

    const items = content.accordionItems;
    const description = content.starLabel;
    const styleAccordion = {
        fontFamily: 'Brix, sans-serif',
        fontSize: '18px',
        fontStyle: 'normal',
        fontWeight: '500',
        lineHeight: '82px',
        color: '#12232C'
    };
    const styleStartLabel = {
        fontFamily: 'Brix, sans-serif',
        fontSize: '18px',
        fontStyle: 'normal',
        fontWeight: '400',
        lineHeight: '27px'
    };
    return (
        <Box pb={isMobile ? "87px" : "122px"}>
            <Flex justifyContent="space-between" alignItems="center" mb={4}>
                <Box flex="1" textAlign="right">
                    <Text sx={styleStartLabel}>{description}</Text>
                </Box>
            </Flex>
            <Accordion allowMultiple>
                {items.map((item, index) => (
                    <AccordionItem key={index}>
                        {({isExpanded}) => (
                            <>
                                <h2>
                                    <AccordionButton>
                                        <Box flex="1" textAlign="left" sx={styleAccordion}>
                                            {item.title}
                                        </Box>
                                        {isExpanded ? (
                                            <CloseIcon fontSize='16px'/>
                                        ) : (
                                            <AddIcon fontSize='16px'/>
                                        )}
                                    </AccordionButton>
                                </h2>
                                <AccordionPanel pb={4} paddingLeft={isMobile ? "0" : "10%"}
                                                paddingRight={isMobile ? "0" : "10%"}
                                                overflowX={isMobile ? "auto" : "hidden"}>
                                    {item.components.map((component, index) =>
                                        <Box key={index} mb="30px">
                                            {getComponentByType(component.type, component.content, index)}
                                        </Box>
                                    )}
                                </AccordionPanel>
                            </>
                        )}
                    </AccordionItem>
                ))}
            </Accordion>
        </Box>
    );
};

export default AccordionComponent;